(window as any).process = {
    env: { DEBUG: undefined },
};

import 'zone.js';  // Included with Angular CLI.
import '@angular/localize/init';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */